import React from 'react'
import {utils_ui} from '../../utils/utils_ui'
import {bool} from "yup";

interface Props {
  iconStr: string,
  title?: string,
  isDisableIconCss?: boolean,
  innerCss?: string,
  extObj?: any,
}
const UI_ApplyooIcon = (props: Props & {className?: string, onClick?: () => void, style?: React.CSSProperties}) => {

  const iconStr = utils_ui.parseApplyooIcon(props.iconStr)

  return (
    <span style={props?.style}
          title={props?.title}
          className={["d-flex zindex-0 applyoo-icon align-items-center justify-content-center",props?.className].join(' ')}
          onClick={props.onClick}>
      <i className={[!props.isDisableIconCss ? 'applyoo-icon mw-icon-xx mx-25 zindex-1' : '',iconStr, props.innerCss].join(" ")}></i>
    </span>)
}

export default UI_ApplyooIcon